import $ from "jquery";

//Programatically opening and closing foundation reveal
//Setting focus to the correct open modal button
let buttonID;

$("#gallery-hero .gallery-hero_image-modal-btn").on("click", function (e) {
    $('#galleryHeroPhotoModal').foundation('open');
    buttonID = $(this);
});

$("#gallery-hero .gallery-hero_video-modal-btn").on("click", function (e) {
    $('#galleryHeroVideoModal').foundation('open');
    buttonID = $(this);
});

$('#galleryHeroPhotoModal').on('closed.zf.reveal', function () {
    $(buttonID).focus();
});

$('#galleryHeroVideoModal').on('closed.zf.reveal', function () {
    $(buttonID).focus();
});

